let request;
let hbr_db;
let version = 2;

export const initDB=()=>{
    return new Promise((resolve,reject)=>{
        request = indexedDB.open("horemowghDB",version);
        request.onsuccess=(event)=>{
            try{
                hbr_db = event.target.result;
                version = hbr_db.version;
                resolve(true);
            }catch(error){
                console.log(error);
            }
        };
        request.onupgradeneeded=(event)=>{
            hbr_db = event.target.result;
            if (!hbr_db.objectStoreNames.contains("hghunitchapterinfo")) {
                hbr_db.createObjectStore("hghunitchapterinfo",{keyPath:'id'});
            }
            if (!hbr_db.objectStoreNames.contains("hghanouncement")) {
                hbr_db.createObjectStore("hghanouncement",{keyPath:'id'});
            }  
            if (!hbr_db.objectStoreNames.contains("hgheventstore")) {
                hbr_db.createObjectStore("hgheventstore",{keyPath:'id'});
            }  
            if (!hbr_db.objectStoreNames.contains("hghtestimonies")) {
                hbr_db.createObjectStore("hghtestimonies",{keyPath:'id'});
            }
            if (!hbr_db.objectStoreNames.contains("hghdocumentid")) {
                hbr_db.createObjectStore("hghdocumentid",{keyPath:'id'});
            }         
        }
        request.onerror=(event)=>{
            reject(`Error opening indexedDB:${event.target.error}`)
        };
    });
};

export const saveChapterUnitName=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hghunitchapterinfo"],'readwrite');
        const objectStore = transaction.objectStore("hghunitchapterinfo");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error saving unit chapter names to database: ${event.target.error}`);
        };
    });
};

export const getChapterUnitName=(id)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(['hghunitchapterinfo']);
         const objectStore = transaction.objectStore("hghunitchapterinfo");
        const request = objectStore.get(id);
        request.onsuccess =(event)=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting unit chapter names: ${event.target.error}`);
        };
    });
};

export const saveApprovedTestimonies=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hghtestimonies"],'readwrite');
        const objectStore = transaction.objectStore("hghtestimonies");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error saving testimonies: ${event.target.error}`);
        };
    });
};

export const getApprovedTestimonies=(id)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(['hghtestimonies']);
         const objectStore = transaction.objectStore("hghtestimonies");
        const request = objectStore.get(id);
        request.onsuccess =(event)=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting testimonies: ${event.target.error}`);
        };
    });
};
export const deleteApprovedTestimonies=(id)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hghtestimonies"],'readwrite');
        const objectStore = transaction.objectStore("hghtestimonies");
        const request = objectStore.delete(id);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error deleting testimonies: ${event.target.error}`);
        };
    });
};

export const saveDocIDs=(data)=>{
    return new Promise((resolve,reject)=>{
        const transaction = hbr_db.transaction(["hghdocumentid"],'readwrite');
        const objectStore = transaction.objectStore("hghdocumentid");
        const request = objectStore.put(data);

        request.onsuccess=(event)=>{
            resolve(true);
        };
        request.onerror=(event)=>{
            reject(`Error saving document id: ${event.target.error}`);
        };
    });
};

export const getSavedDocIDs=(id)=>{
    return new Promise((resolve,reject) =>{
        const transaction = hbr_db.transaction(['hghdocumentid']);
         const objectStore = transaction.objectStore("hghdocumentid");
        const request = objectStore.get(id);
        request.onsuccess =(event)=>{
            resolve(request.result);
        };
        request.onerror =(event)=>{
            reject(`Error getting document id: ${event.target.error}`);
        };
    });
};